export default __webpack_public_path__ + "static/media/school (1).fbdba2a7.svg";